/**
 * Fallback del <Suspense> de las rutas lazy (src/App.tsx).
 *
 * Antes era `() => null` → pantalla en blanco mientras baja el chunk de la ruta.
 * Ahora, simplemente, la pantalla toma el violeta claro de la app (#f5f3ff, el mismo
 * del hero) en vez de blanco. En dark, el neutro oscuro de siempre. Sin skeleton.
 *
 * El mismo color lo pinta index.html (skeleton inline) para la entrada directa por URL,
 * antes de que bootee React.
 */
export default function RouteFallback() {
  return <div className="min-h-screen bg-violet-50 dark:bg-neutral-900" />;
}
